import React, { useEffect } from "react";

const BottomSheet = ({ isOpen, onClose, title, children }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
    } else {
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.width = '';
    }
    return () => {
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.width = '';
    };
  }, [isOpen]);

  return (
    <>
      {/* Overlay */}
      <div
        className={`fixed inset-0 bg-black/50 z-[200] transition-opacity duration-300 ${isOpen ? 'opacity-100 visible' : 'opacity-0 invisible'}`}
        onClick={onClose}
      />

      {/* Sheet */}
      <div className={`fixed bottom-0 left-0 right-0 z-[210] bg-surface rounded-t-2xl shadow-lg transform transition-transform duration-300 flex flex-col
        ${isOpen ? 'translate-y-0' : 'translate-y-full'}`}
        style={{ maxHeight: '80vh', paddingBottom: 'env(safe-area-inset-bottom, 16px)' }}>
        
        {/* Handle */}
        <div className="flex justify-center pt-3 pb-1 flex-shrink-0">
          <div className="w-10 h-1 rounded-full bg-outline-variant" />
        </div>

        {/* Header */}
        <div className="flex items-center justify-between px-5 py-3 border-b border-outline-variant flex-shrink-0">
          <h3 className="text-body-lg font-bold text-on-surface">{title || "Chi tiết"}</h3>
          <button onClick={onClose} className="w-8 h-8 rounded-full flex items-center justify-center hover:bg-surface-container transition-colors">
            <span className="material-symbols-outlined text-on-surface-variant">close</span>
          </button>
        </div>

        {/* Body - SCROLL ĐƯỢC + KHÔNG BỊ CHE */}
        <div className="flex-1 overflow-y-auto overscroll-contain px-5 py-4" style={{ paddingBottom: '80px' }}>
          {children}
        </div>
      </div>
    </>
  );
};

export default BottomSheet;